<template>
  <container>
    <div slot="left_box_content">
      <component :is="curLeftComponent"></component>
    </div>

    <div slot="right_box_content">
      <component :is="curRightComponent" ></component>
    </div>

    <div slot="bottom_box_content">
      <component :is="curBottomComponent" ></component>
    </div>

    <div slot="center_box_content">
      <component :is="curMapComponent" ></component>
    </div>
  </container>
</template>

<script>
import Container from '@/components/common/Container_DataV'
import { sysMixins } from '@/assets/mixins/sys'
// 引入store模块
import situationStoreModule from '@/store/modules/situation_web'
import { getWeekFirstDay, ParseDate, GetDateStr } from '@/utils/dateFormat'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    Bottom: () => import('./components/Bottom'),
    Right: () => import('./components/Right'),
    Left: () => import('./components/Left'),
    Center: () => import('./components/Center')
  },
  created () {
    // 注册动态store模块
    if (!this.$store.hasModule('situationWeb')) {
      this.$store.registerModule('situationWeb', situationStoreModule)
    }
  },
  mounted () {
    const schedule = {
      startDate: getWeekFirstDay(),
      endDate: ParseDate(new Date())
    }
    this.$store.commit('set_situation_searchSchedule', schedule)

    const preWeekDay = GetDateStr(new Date(), -6)
    const compareSchedule = {
      startDate: getWeekFirstDay(preWeekDay),
      endDate: preWeekDay
    }
    this.$store.commit('set_situation_compareSchedule', compareSchedule)

    this.setLeftComponent('Left')
    this.setRightComponent('Right')
    this.setBottomComponent('Bottom')
    this.setMapComponent('Center')

    this.setBottomHeight('92%')
  },
  destroyed () {
    // 卸载installSetting动态store模块
    this.$store.commit('reset_state')
    // this.$store.unregisterModule('situationWeb')
  }
}
</script>
